import React from 'react';
import Header from './components/Header10';
import Footer from './components/Footer10';

const About10 = () => {
    return (
        <>
            <link href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600&display=swap" rel="stylesheet" />

            <div style={{ fontFamily: "'Inter', sans-serif" }} className="min-h-screen bg-white">
                <Header />

                <main className="pt-16 md:pt-[72px]">
                    {/* Page Header */}
                    <div className="py-16 md:py-28 px-5 md:px-8 text-center">
                        <p className="text-[#A8A29E] text-[10px] md:text-xs tracking-[3px] uppercase mb-4">Our Story</p>
                        <h1 className="text-3xl md:text-5xl lg:text-6xl font-light text-[#1C1917] tracking-tight leading-tight max-w-2xl mx-auto">
                            Simplicity is the ultimate sophistication
                        </h1>
                    </div>

                    {/* Divider */}
                    <div className="w-16 h-px bg-[#78716C] mx-auto" />

                    {/* Philosophy */}
                    <section className="max-w-[700px] mx-auto px-5 md:px-8 py-16 md:py-24">
                        <p className="text-[#57534E] text-base md:text-lg font-light leading-[1.8] mb-8">
                            STHIR was born from a quiet rebellion against the noise of fast fashion. We believe that
                            true style does not shout. It whispers. It lives in the quality of the thread, the patience
                            of the weaver, and the restraint of the designer.
                        </p>
                        <p className="text-[#57534E] text-base md:text-lg font-light leading-[1.8] mb-8">
                            Every piece in our collection is a conversation between ancient Indian textile traditions
                            and a modern, minimal aesthetic. We work with artisan clusters across India &mdash; from the
                            handloom weavers of West Bengal to the block printers of Jaipur &mdash; preserving techniques
                            that have been passed down through generations.
                        </p>
                        <p className="text-[#57534E] text-base md:text-lg font-light leading-[1.8]">
                            We do not chase trends. We curate essentials. Pieces that work harder so you can think
                            less about what to wear and more about how to live. Our commitment is to fewer, better
                            things &mdash; clothing that ages gracefully and tells a story with every wear.
                        </p>
                    </section>

                    {/* Values */}
                    <section className="bg-[#FAFAF9] py-16 md:py-24" style={{ borderTop: '1px solid #E7E5E4', borderBottom: '1px solid #E7E5E4' }}>
                        <div className="max-w-[900px] mx-auto px-5 md:px-8">
                            <p className="text-[#A8A29E] text-xs tracking-[3px] uppercase mb-10 md:mb-14 text-center">What We Stand For</p>
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-16">
                                {[
                                    {
                                        title: 'Honest Materials',
                                        text: 'Only natural fibres. Pure cotton, handwoven linen, organic khadi. No synthetics, no shortcuts.',
                                    },
                                    {
                                        title: 'Artisan Made',
                                        text: 'Every garment is handcrafted by skilled artisans. We pay fair wages and invest in their communities.',
                                    },
                                    {
                                        title: 'Mindful Design',
                                        text: 'We design with restraint. Each piece is considered, versatile, and built to last through seasons.',
                                    },
                                ].map((value, index) => (
                                    <div key={index} className="text-center md:text-left">
                                        <h3 className="text-[#1C1917] text-sm font-normal tracking-wider mb-3">{value.title}</h3>
                                        <p className="text-[#78716C] text-sm font-light leading-relaxed">{value.text}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </section>

                    {/* Quote */}
                    <section className="py-20 md:py-32">
                        <div className="max-w-2xl mx-auto px-5 md:px-8 text-center">
                            <blockquote className="text-xl md:text-2xl lg:text-3xl font-light text-[#1C1917] leading-relaxed mb-8 italic">
                                &ldquo;Have nothing in your house that you do not know to be useful, or believe to be beautiful.&rdquo;
                            </blockquote>
                            <cite className="text-[#A8A29E] text-xs tracking-[2px] uppercase not-italic">
                                &mdash; William Morris
                            </cite>
                        </div>
                    </section>

                    {/* Numbers */}
                    <section className="py-14 md:py-20" style={{ borderTop: '1px solid #E7E5E4' }}>
                        <div className="max-w-[900px] mx-auto px-5 md:px-8">
                            <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
                                {[
                                    { number: '200+', label: 'Artisans Supported' },
                                    { number: '12', label: 'Weaving Communities' },
                                    { number: '100%', label: 'Natural Fibres' },
                                    { number: '0', label: 'Synthetic Blends' },
                                ].map((stat, index) => (
                                    <div key={index}>
                                        <p className="text-[#1C1917] text-2xl md:text-3xl font-light mb-1">{stat.number}</p>
                                        <p className="text-[#A8A29E] text-xs font-light">{stat.label}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </section>
                </main>

                <Footer />
            </div>
        </>
    );
};

export default About10;
